import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import { PersonaSize } from '@fluentui/react';
import {
  TeamWidgetSuggestionContainer,
  TeamWidgetSuggestionPersona,
  TeamWidgetSuggestionEmployeeName,
  TeamWidgetSuggestionGroupDisplayName,
  TeamWidgetSuggestionGroupNameHeader,
  TeamWidgetSuggestionOptionsWrapper,
} from './styles/TeamWidgetSuggestionSection.styled';
import { handleKeyDownSelect } from './utils/handleKeyDown';
import { Employee } from 'src/tabs/hooks/useGetAllUsers';
import { ColorCodedEmployee } from './TeamWidgetSection';

interface TeamWidgetSuggestionSectionProps {
  isSuggetionsVisible: boolean;
  selectorRef: MutableRefObject<HTMLUListElement>;
  inputRef: MutableRefObject<HTMLDivElement>;
  teamOptions: Array<Employee>;
  setTeam: Dispatch<SetStateAction<Array<ColorCodedEmployee>>>;
  setInputValue: Dispatch<string>;
  setTeamOptions: Dispatch<Array<Employee>>;
  handleOptionClick: (option: Employee) => void;
  groups: { [k in string]: string }[];
  getGroupUsers: (groupId: string) => Promise<void>;
}

export const TeamWidgetSuggestionSection = ({
  inputRef,
  isSuggetionsVisible,
  selectorRef,
  teamOptions,
  handleOptionClick,
  groups,
  getGroupUsers,
}: TeamWidgetSuggestionSectionProps) => {
  return (
    <>
      {isSuggetionsVisible && (
        <div autoFocus>
          <TeamWidgetSuggestionContainer
            ref={selectorRef}
            onKeyDown={(e) => handleKeyDownSelect(e, selectorRef, inputRef)}
          >
            {teamOptions.length > 0 && (
              <div>
                <TeamWidgetSuggestionGroupNameHeader>
                  People
                </TeamWidgetSuggestionGroupNameHeader>
                <TeamWidgetSuggestionOptionsWrapper>
                  {teamOptions.slice(0, 5).map((teamMember) => {
                    return (
                      <li
                        key={teamMember.new_name}
                        onClick={() => handleOptionClick(teamMember)}
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleOptionClick(teamMember);
                          }
                        }}
                      >
                        <TeamWidgetSuggestionPersona
                          text={teamMember.new_name}
                          size={PersonaSize.size32}
                        />
                        <div>
                          <TeamWidgetSuggestionEmployeeName>
                            {teamMember.new_name}
                          </TeamWidgetSuggestionEmployeeName>
                        </div>
                      </li>
                    );
                  })}
                </TeamWidgetSuggestionOptionsWrapper>
              </div>
            )}

            {groups?.length > 0 && (
              <div>
                <TeamWidgetSuggestionGroupNameHeader>
                  Groups
                </TeamWidgetSuggestionGroupNameHeader>
                <TeamWidgetSuggestionOptionsWrapper>
                  {groups?.slice(0, 5).map((obj) => {
                    const [[id, displayName]] = Object.entries(obj);

                    return (
                      <li
                        key={id}
                        onClick={() => getGroupUsers(id)}
                        tabIndex={0}
                      >
                        <TeamWidgetSuggestionGroupDisplayName>
                          {displayName}
                        </TeamWidgetSuggestionGroupDisplayName>
                      </li>
                    );
                  })}
                </TeamWidgetSuggestionOptionsWrapper>
              </div>
            )}
          </TeamWidgetSuggestionContainer>
        </div>
      )}
    </>
  );
};
